import type { ZipcodeInfo } from '@/types/zipcode';

export async function fetchZipcodeInfo(
  zipcode: string
): Promise<ZipcodeInfo | null> {
  if (!/^\d{5}$/.test(zipcode)) {
    return null;
  }

  try {
    const response = await fetch(`/api/zipcode/${zipcode}`);

    if (!response.ok) {
      return null;
    }

    const data = (await response.json()) as ZipcodeInfo;
    return data;
  } catch {
    return null;
  }
}
